.root {
  width: var(--haus-variantspecifications__root__width, 100%);
  margin: var(--haus-variantspecifications__root__margin, 0);
  padding: var(--haus-variantspecifications__root__padding, 0);
  border-collapse: var(--haus-variantspecifications__root__border-collapse, separate);
  border-spacing: var(--haus-variantspecifications__root__border-spacing, 0);
}

.row {
  display: var(--haus-variantspecifications__row__display, block);
  background-color: var(--haus-variantspecifications__row__background-color, transparent);
}

.row:nth-child(odd) {
  background-color: var(--haus-variantspecifications__rowOdd__background-color, #f7f7f7);
}

.row:nth-child(even) {
  background-color: var(--haus-variantspecifications__rowEven__background-color, #ffffff);
}

.label {
  display: var(--haus-variantspecifications__label__display, block);
  padding: var(--haus-variantspecifications__label__padding, 8px 8px 0 8px);
  font-weight: var(
    --haus-variantspecifications__label__font-weight,
    var(--haus-typography-body-font-weight, 600)
  );
  color: var(--haus-variantspecifications__label__color, var(--haus-color-body, #323231));
  text-align: var(--haus-variantspecifications__label__text-align, left);
}

.value {
  display: var(--haus-variantspecifications__value__display, block);
  padding: var(--haus-variantspecifications__value__padding, 0 8px 8px 8px);
  color: var(--haus-variantspecifications__value__color, var(--haus-color-body, #323231));
}

@include bp.tablet-min {
  .root {
    --haus-variantspecifications__root__display: table;
    --haus-variantspecifications__root__border-collapse: collapse;
  }

  .row {
    --haus-variantspecifications__row__display: table-row;
    --haus-variantspecifications__row__padding: 16px 10px;
  }

  .label {
    --haus-variantspecifications__label__display: table-cell;
    --haus-variantspecifications__label__padding: 16px 10px;
    --haus-variantspecifications__label__font-weight: 700;
  }

  .value {
    --haus-variantspecifications__value__display: table-cell;
  }
}
